import React from "react";
import { SlidePages } from "../../components/slidePages";
import { Introduction } from "../../components/apropos/intro";
import { Mission } from "../../components/apropos/mission";
import { Intervention } from "../../components/apropos/intervention";
import { Engagements } from "../../components/apropos/engagements";
import { Equipe } from "../../components/apropos/equipe";
import { Partenaire } from "../../components/home/nosPartenaire";

export const AproposPage = () => {
  return (
    <div>
      <SlidePages title={"À propos de Habitat IDF"} />
      <Introduction />
      <Mission />
      <Intervention />
      <Engagements />
      <Equipe />
      <Partenaire />
    </div>
  );
};
